// extracted by mini-css-extract-plugin
export var shawStarterPack = "StarterKit-module--shawStarterPack--3iKvG";
export var starterPackBackground = "StarterKit-module--starterPackBackground--hV3Ai";
export var starterPackContent = "StarterKit-module--starterPackContent--1Md7z";
export var starterPackHeader = "StarterKit-module--starterPackHeader--1THfT";
export var starterPackInfo = "StarterKit-module--starterPackInfo--WZ7lA";
export var starterPackFiles = "StarterKit-module--starterPackFiles--1OSwJ";
export var singlePack = "StarterKit-module--singlePack--2e-Dq";
export var buttonWrapper = "StarterKit-module--buttonWrapper--2stOV";